export enum SalesStatusEnum {
  AUTHORIZED = "AUTHORIZED",
  CANCELLED = "CANCELLED",
  FUTURE = "FUTURE",
  PAYMENT_ERROR = "PAYMENT_ERROR",
}
export enum SalesRequestTypeEnum {
  RECURRING = "RECURRING",
  ROTARY = "ROTARY",
}
